export const STANDARD_COLOR_PALETTE_SIZE = 24;
export const STANDARD_COLOR_PALETTE_COLUMNS = 8;

export const STANDARD_COLOR_PALETTE = [
  "#111827",
  "#374151",
  "#6b7280",
  "#ffffff",
  "#ef4444",
  "#f97316",
  "#f59e0b",
  "#eab308",
  "#84cc16",
  "#22c55e",
  "#10b981",
  "#14b8a6",
  "#06b6d4",
  "#0ea5e9",
  "#3b82f6",
  "#6366f1",
  "#8b5cf6",
  "#a855f7",
  "#d946ef",
  "#ec4899",
  "#f43f5e",
  "#92400e",
  "#7c2d12",
  "#000000",
];

export function normalizeHexColor(value: string | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  const match = trimmed.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (!match) return null;
  const raw = match[1].toLowerCase();
  if (raw.length === 3) {
    return `#${raw
      .split("")
      .map((char) => `${char}${char}`)
      .join("")}`;
  }
  return `#${raw}`;
}

export function areSameColor(a: string | undefined, b: string | undefined) {
  const normalizedA = normalizeHexColor(a);
  const normalizedB = normalizeHexColor(b);
  return !!normalizedA && !!normalizedB && normalizedA === normalizedB;
}

export function normalizeStandardColorPalette(colors: unknown): string[] {
  const validColors = Array.isArray(colors)
    ? colors
        .map((color) =>
          typeof color === "string" ? normalizeHexColor(color) : null
        )
        .filter((color): color is string => !!color)
    : [];

  return Array.from({ length: STANDARD_COLOR_PALETTE_SIZE }, (_, index) => {
    return validColors[index] ?? STANDARD_COLOR_PALETTE[index];
  });
}
